<!-- src/views/LoginPage.vue -->
<template>
  <div class="login-page">
    <div class="login-container">

      <div class="logo-container">
        <img :src="require('@/assets/logo.png')" alt="Logo" class="logo" />
      </div>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <v-text-field
              v-model="email"
              label="E-mail"
              hide-details
              required
          ></v-text-field>
        </div>
        <div class="form-group">
          <div class="password-container">
            <v-text-field
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                label="Mot de passe"
                required
                @click:append="showPassword = !showPassword"
            ></v-text-field>
          </div>
        </div>
        <button v-if="loading" class="login-button">
            <v-progress-circular
                indeterminate
                size="12"
                width="2"
                style="color: #fff"
            />
        </button>
        <button v-else type="submit" class="login-button">Se connecter</button>
      </form>
      <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    </div>
    <v-dialog v-model="showModal" width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Accès refusé</span>
        </v-card-title>
        <v-card-text>
          <p>Votre rôle ne vous permet pas de vous connecter à l'application.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="showModal = false"
          >Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

export default {
  name: 'LoginPage',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      loading: false,
      showPassword: false,
      showModal: false
    };
  },
  methods: {
    async handleLogin() {
      this.loading = true;
      try {
        const res = await this.$http.post('/auth/login', {
          email: this.email,
          password: this.password,
        });

        const { accessToken: token, roles: role } = res.data;

        if (token && role[0] === 'scriptwriter') {
          localStorage.setItem('authToken', token);
          await this.$router.push({ name: 'Home' });
        } else if (role && role[0] !== 'scriptwriter') {
          this.showModal = true
        } else {
          this.errorMessage = 'Aucun token reçu. Vérifiez vos informations.';
        }
      } catch (error) {
        this.loading = false;
        if (error.response && error.response.status === 500) {
          this.errorMessage = "Erreur interne du serveur (500). Veuillez réessayer plus tard.";
        } else {
          this.errorMessage = 'Erreur de connexion. Veuillez vérifier vos informations.';
        }
        console.error('Erreur de connexion:', error);
      } finally {
        this.loading = false;
      }
    },

  },

  created() {
    const token = localStorage.getItem('authToken');
    if (token) {
          this.$router.push({ name: 'Home' });
    }
  },
};
</script>

<style scoped>
/* Styles de base pour la page de connexion */
.login-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #ECF9F7;
}

/* Conteneur du logo */
.logo-container {
  margin-bottom: 30px;
}

.logo {
  width: 100px;
}

/* Conteneur principal pour le formulaire de connexion */
.login-container {
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.title {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

/* Style pour les champs de formulaire */
.form-group {
  margin-bottom: 20px;
  text-align: left;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #333;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 16px;
}

/* Style du bouton de connexion */
.login-button {
  width: 100%;
  padding: 12px;
  background-color: #53C29C;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.login-button:hover {
  background-color: #42e3c2;
}

/* Style pour le message d'erreur */
.error {
  margin-top: 20px;
  color: white;
}

.password-container {
  position: relative;
}

</style>
